<template>
    <div id="app">
        <div class="loader" v-if="loader">{{$t('loading')}} ...</div>
        <div v-else>
            <a-layout id="components-layout-demo-custom-trigger">
                <a-layout-sider :trigger="null" collapsible v-model="collapsed" :style="{ overflow: 'auto', height: '100vh', position: 'fixed', left: 0, background: '#fff'}">
                    <div>
                        <a-menu @click="handleClick"
                                :defaultSelectedKeys="['1']"
                                :selectedKeys="selectMenu()">
                            <a-menu-item key="dashboard">
                                <a-icon type="dashboard"/>
                                <span><router-link to="/dashboard"
                                                   class="nav-link">{{$t('Dashboard')}}</router-link></span>
                            </a-menu-item>
                            <a-menu-item key="important">
                                <a-icon type="info-circle"/>
                                <span><router-link to="/page/sk/important"
                                                   class="nav-link">{{$t('Important information')}}</router-link></span>
                            </a-menu-item>
                            <a-menu-item key="accomodations">
                                <a-icon type="appstore"/>
                                <span><router-link to="/accomodations"
                                                   class="nav-link">{{$t('Accomodations')}}</router-link></span>
                            </a-menu-item>
                            <a-menu-item key="myaccount">
                                <a-icon type="setting"/><span><router-link to="/myaccount" class="nav-link">{{$t('My account')}}</router-link></span>
                            </a-menu-item>
                            <a-menu-item key="11">
                                <span> <a-icon type="crown"/><span><router-link to="/page/sk/zlavy-akcie" class="nav-link">{{$t('Discounts')}}</router-link></span></span></a-menu-item>
                            <a-menu-item key="12">
                                <a-icon type="mail"/>
                                <span>{{$t('Giftcards')}}</span></a-menu-item>
                            <a-menu-item key="13">
                                <span> <a-icon type="heart"/><span><router-link to="/page/sk/sutaz" class="nav-link">{{$t('Contest')}}</router-link></span></span></a-menu-item>
                            <a-menu-item key="14">
                                <a-icon type="environment"/>
                                <span>{{$t('Contact')}}</span></a-menu-item>
                        </a-menu>
                    </div>
                </a-layout-sider>
                <a-layout :style="{ marginLeft: '200px' }">
                    <a-layout-content
                            :style="{ margin: '24px 16px', padding: '24px', background: '#fff', minHeight: '280px', marginBottom: '200px' }"
                    >
                        <router-view/>
                    </a-layout-content>
                </a-layout>
            </a-layout>
        </div>
    </div>
</template>

<script>
import {dataService} from '../_services'
import {Menu, Icon, Layout} from 'ant-design-vue'
import ARow from 'ant-design-vue/es/grid/Row'
import ACol from 'ant-design-vue/es/grid/Col'
import ALayoutSider from 'ant-design-vue/es/layout/Sider'
import '../assets/styles/weather-icons.css'

export default {
  name: 'App',
  data () {
    this.$i18n.locale = 'sk'
    return {
      loader: true,
      activeClass: 'active',
      hostData: '',
      collapsed: false
    }
  },
  comupted: {},
  components: {
    ALayoutSider,
    ACol,
    ARow,
    'a-layout': Layout,
    'a-layout-content': Layout,
    'a-menu': Menu,
    'a-menu-item': Menu.Item,
    'a-sub-menu': Menu.SubMenu,
    'a-icon': Icon
  },
  beforeCreate () {
    dataService.axiosFetch('client').then(results => {
      window.hostData = results
      this.$i18n.locale = window.hostData.language
    })
  },
  methods: {

    selectMenu () {
      let add = this.$route.path
      let route = add.split('/')[1]
      return [route]
    },
    handleClick (e) {
      e.item.$children['1'].$el.click()
    }
  },
  mounted () {
    this.loader = false
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  }
}

</script>

<style>
    .reservation {
        border-bottom: 2px solid #f0f0f0;
        padding-bottom: 20px;
        margin-bottom: 20px;
    }

    .price {
        width: 100%;
    }

    .options button {
        display: block;
        margin: 10px auto;
    }

    .price span {
        font-size: 25px;
        float: right;
        margin-right: 15px;
    }

    #components-layout-demo-custom-trigger .trigger {
        font-size: 18px;
        line-height: 64px;
        padding: 0 24px;
        cursor: pointer;
        transition: color 0.3s;
    }

    #components-layout-demo-custom-trigger .trigger:hover {
        color: #1890ff;
    }

    #components-layout-demo-custom-trigger .logo {
        height: 32px;
        background: rgba(255, 255, 255, 0.2);
        margin: 16px;
    }

    .ant-menu a {
        color: inherit;
    }

    h2 {
        color: #0d1a26;
        font-family: Avenir, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
        font-variant: tabular-nums;
        margin-bottom: 1.6em;
        font-weight: 500;
        clear: both;
    }
    .product-image {
        width: 100%;
        display: block;
        border: 4px solid #fff;
        outline: 2px solid #e8f7ff;
        margin: 0;
    }

    .alerts-details, .recommend-title {
        display: inline-block;
        background-color: #fff;
        border: 2px solid #e8f7ff;
        padding: 0.2em 0.8em;
        font-size: 14px;
        text-transform: uppercase;
    }

    .ant-btn:not(.ant-btn-link) {

        font-size: 14px;
        color: rgba(0,0,0,.65);
        background-color: #fff;
        border: 1px solid #5d5063;
    }
  .ant-btn.ant-btn-primary {
        display: block;
        text-align: center;
        font-size: 14px;
        text-transform: uppercase;
        margin-bottom:30px;
      float:right;
        margin-left:15px;
        background-color: #5d5063;
        color: #fff;
        border: 3px solid transparent;
    }
    .ant-btn.ant-btn-primary.change
    {float:none;}
    .ant-btn:focus, .ant-btn:hover {
        color: #fff;
        background-color: #413847;
        border-color: #342e39;

    }
    .ant-btn-link {
        color: #c19368;
    }
    .recommend-title {
        margin: 0;
        margin-bottom: 10px;
        position: relative;
        display: inline-flex;
    }

    .price-description {
        float: left;
        font-size: 12px;
        color: #818181;
        font-weight: bold;
        vertical-align: text-bottom;
    }

    .options {
        text-align: center;
        margin-top: 30px;
    }
    .ant-table-tbody>tr>td, .ant-table-thead>tr>th
    {padding:10px}
    .additional-info {
        border-left: 2px solid #f0f0f0;
    }

    .weather-forecast {
        margin-top: 20px;
        padding-bottom: 20px;
    }

    .alert-icon {
        font-size: 30px;
        display: block;
        margin: 0 auto;
        color: #80ce8e;
    }

    .critical .alert-icon {
        color: #ea7d7d;
    }

    .moderate .alert-icon {
        color: #6db9ea;
    }
    h4.product-title
    {margin:0;}
    .dates
    {font-size:20px;font-weight:bold;margin:0;}
    .recommendations {
        border: 2px solid #f0f0f0;
        padding: 1em .2em;
        background-color: #f7f7f7;
        display: inline-flex;

    }

    .snow-conditions h4 {
        margin-top: 30px;
        margin-bottom:10px;
    }

    .weather-forecast h4, .snow-conditions h4 {
        text-transform: uppercase;
    }

    .day-1 .day-night {
        display: inline-block;
        width: 100%;
        margin-top: 10px;
        font-size: 12px;
    }

    .word-forecast {
        font-size: 12px;
        margin-top: 10px;
        margin-left: 12px;

    }

    .text-center {
        text-align: center
    }

    .day-1 {
        border-right: 2px solid #f0f0f0
    }

    .day-1 .weather-icon {
        font-size: 50px;
    }

    .day-1 .date {
        font-size: 14px;
        font-weight: bold;
        display: inline-block;
        width: 100%;
        text-align: center;

    }

    .day-other .date {
        font-size: 12px;
        margin-left: 10px;
        font-weight: bold;
    }

    .recommendations .price {
        font-size: 10px;
    }

    .day-other .day-night {
        font-size: 12px;
    }

    .recommendations .price span {
        font-size: 18px;
    }

    .day-other .weather-icon {
        margin-right: 20px;
        font-size: 20px;
    }

    .day-other .date {
        margin-right: 20px;
    }

    .additional-info-message p {
        margin: 0
    }

    .additional-info-message {
        padding-left: 20px;
        border-bottom: 1px solid #f0f0f0;
        padding-bottom: 5px;
    }

    .day-other, .date-title {
        border-bottom: 1px solid #f0f0f0;
        padding-bottom: 5px;
        margin-bottom: 5px;
    }

    .date-title {
        padding-left: 15px;
        font-size: 14px;
        background-color: #f7f7f7;
        padding-top: 5px;
    }

    .detail-info {
        margin-top: 15px;
    }

    .roomname, .detailed {
        font-size: 12px;
        font-weight: 400;
    }

    .reservation {
        border-bottom: 2px solid #f0f0f0;
        padding-bottom: 20px;
        margin-bottom: 20px;
    }

    .price {
        width: 100%;
    }

    .options button {
        display: block;
        margin: 10px auto;
    }

    .price span {
        font-size: 25px;
        float: right;
        margin-right: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/layout/DashboardLayout.vue